import { render, staticRenderFns } from "./BiewBadge.vue?vue&type=template&id=7f830eee&scoped=true&"
import script from "./BiewBadge.vue?vue&type=script&lang=js&"
export * from "./BiewBadge.vue?vue&type=script&lang=js&"
import style0 from "./BiewBadge.vue?vue&type=style&index=0&id=7f830eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f830eee",
  null
  
)

export default component.exports